import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import Operations from "../views/Operations.vue";
import Finance from "../views/Finance.vue";
import Merchandiser from "../views/Merchandiser.vue";
import PhoneDeliveryItems from "../views/PhoneDeliveryItems.vue";
import StoreOperation from "../views/StoreOperation.vue";
import Marketing from "../views/Marketing.vue";
import Alliance from "../views/Alliance.vue";
import SRD from "../views/SRD.vue";
import SOP from "../views/SOP.vue";
import legal from "../views/legal.vue";
// import b2b from "../views/b2b.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    redirect: "/home/disha"
  },
  { path: "/home/:id", component: Home },
  { path: "/home/disha/operations", component: Operations },
  { path: "/home/disha/StoreOperation", component: StoreOperation },
  { path: "/home/disha/finance", component: Finance },
  { path: "/home/disha/marketing", component: Marketing },
  { path: "/home/disha/alliance", component: Alliance },
  { path: "/home/disha/srd", component: SRD },
  { path: "/home/disha/SOP", component: SOP },
  { path: "/home/disha/legal", component: legal },
  { path: "/home/disha/merchandiser", component: Merchandiser },
  { path: "/home/ivr/:id", component: PhoneDeliveryItems },
 
 
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

export default router;
